import Vue from 'vue'

Vue.filter('datetime', function (value) {
  if (!value) return ''
  const d = new Date(value);
  return d.toLocaleString();
})
